import Swal from "sweetalert2";
import '@sweetalert2/theme-material-ui/material-ui.scss';

"use strict"

const $ = jQuery;

$(async function () {

    const result = await Swal.fire({
        template: "#manage-my-subscriptions",
        width: "650px",
        showLoaderOnConfirm: true,
        didOpen: () => {
            $('.swal2-input').attr('id', 'subscriptions-email-address');
            $('.swal2-confirm').attr('id', 'send-email-link');
        },
        allowOutsideClick: () => !Swal.isLoading(),
        preConfirm: processInput
    });

    if (result.isConfirmed) {
        await Swal.fire({
            title: 'Email sent',
            html: result.value.message,
            didOpen: () => {
                $('.swal2-confirm').attr('id', 'confirm-subscription-link-send')
            },
        });
    }

    redirect();

    /**
     * Processes modal input.
     *
     * @param emailAddress
     * @returns {Promise<any>}
     */
    async function processInput(emailAddress) {
        try {
            validateEmailOrThrow(emailAddress)

            return JSON.parse(await sendConfirmationEmailRequest(emailAddress));
        }
        catch (error) {
            Swal.showValidationMessage(error);
        }
    }

    /**
     * Sends an AJAX request to send a subscription management email to the provided address.
     * @param emailAddress The address to send a management link to.
     * @returns {JQuery.jqXHR<any>}
     */
    async function sendConfirmationEmailRequest(emailAddress) {
        return $.post(
            window.ajax_url,
            {
                'action': 'send-manage-subscriptions-link',
                'email-address': emailAddress
            }
        );
    }

    /**
     * Redirects the user away from the modal page.
     */
    function redirect() {
        const currentURL = window.location.toString();
        const deeplinkIndex = currentURL.indexOf('manage-my-subscriptions');
        if (0 !== deeplinkIndex) {
            const newURL = currentURL.substring(0, deeplinkIndex - 1);
            window.location = newURL;
        }
    }

    /**
     * Displays if the email is valid or not, returning the same
     * @param emailAddressInput The input email address to validate.
     */
    function validateEmailOrThrow(emailAddressInput) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(String(emailAddressInput).toLowerCase()))
        {
            throw new Error('Please enter a valid email address');
        }
    }
});